import { showNotification } from '@mantine/notifications'

/**
 * What `PATCH /appointment/{id}/status` reports about the Zocdoc booking behind a visit.
 *
 * Hand-written because the published `@behuman.corp/contracts` has not been regenerated since the
 * middleware added these fields. All absent for a visit that is not bound to Zocdoc.
 */
export type StatusChangeResult = {
  zocdocSynced?: boolean
  zocdocMessage?: string
  /** Confirming accepted the patient's pending Zocdoc reschedule and moved the visit here. */
  zocdocMovedTo?: string
}

/**
 * The notification after a status change, shared by the Schedule page and the appointment modal.
 *
 * Ours is recorded either way. A Zocdoc half that did not go through is said out loud and stays on
 * screen: the booking there still shows the old status, and only a person can finish it.
 */
export function notifyStatusChange(result: StatusChangeResult | undefined): void {
  if (result?.zocdocSynced === false) {
    showNotification({
      color: 'yellow',
      title: 'Updated here, but not on Zocdoc',
      message: result.zocdocMessage ?? 'Zocdoc did not take the change.',
      autoClose: false,
    })
    return
  }
  showNotification({
    color: 'green',
    message: result?.zocdocMovedTo
      ? 'Confirmed here and on Zocdoc — the visit moved to the time the patient asked for'
      : result?.zocdocSynced
        ? 'Appointment status updated here and on Zocdoc'
        : 'Appointment status updated',
  })
}
